import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
// WAYP-561: react-datepicker stylesheet — global import so the DatePicker /
// TimePicker / DateTimePicker wrappers in core/components/ui render with
// default calendar styling.
import 'react-datepicker/dist/react-datepicker.css';
// WAYP-561 polish: scoped overrides that align react-datepicker with the
// project's form-input design tokens. MUST load AFTER the default stylesheet
// so our rules win specificity ties.
import './core/components/ui/pickers.css';
// WAYP-316: i18n bilingual support (must import before App renders)
import './lib/i18n/i18n';
// Durable global Google Maps auth-failure guard — suppresses Google's default
// "This page can't load Google Maps correctly" popup (shown on an invalid /
// unauthorised key) so address autocomplete inputs degrade to plain text.
import { installGoogleMapsAuthGuard } from './lib/google-maps-auth-guard';

// Dark mode is intentionally disabled; force light mode before React boots.
// Moved out of an inline <script> in index.html so the strict server CSP
// (`script-src 'self' https://maps.googleapis.com`, no 'unsafe-inline'/nonce)
// stops blocking it on every route.
try {
  document.documentElement.classList.remove('dark');
  localStorage.setItem('waypoint-theme', 'light');
} catch {
  // ignore storage access issues
}

// Guarantee a defined gm_authFailure handler for the whole app lifetime so
// Google never falls back to its default error dialog when a Maps/Places key
// fails to authenticate. Must run before any form mounts a Places widget.
installGoogleMapsAuthGuard();

// Vite fires `vite:preloadError` when a lazily-imported chunk fails to load —
// almost always because a deploy replaced the hashed chunk this (stale) tab
// is still requesting. Reload to pull the fresh index.html + new hashes rather
// than leaving a blank page. RootErrorBoundary is the in-React backstop.
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
